import classNames from "classnames"
import { useLayout } from "../../hooks/context/useLayout";
import { useNotification } from "../../hooks/context/useNotification";

type NotificationButtonProps = {
  isMobile?: boolean;
}

const NotificationButton = ({ isMobile }: NotificationButtonProps) => {
  const { openNotification } = useLayout();
  const { notificationList } = useNotification();

  return (
    <div className={classNames({
        'notification-header': true,
        'is-notification': notificationList.length,
        'hidden-desktop': isMobile
    })}>
        <button className="toggle-notification" type="button" onClick={openNotification}>
            <i className="icon-notification" />
        </button>
    </div>
  )
}

export default NotificationButton